import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import toJS from '../hoc/toJS'
import getData from '../functions/getData'
import { CLI_CURRENT_CINEMA_ID, PROGRAM_HIGHLIGHTS, PROGRAM_MOVIES_ITEMS } from '../constants/state'
import ItemMovieAccess from './ItemMovieAccess'

const mapStateToProps = (state, ownProps) => ({
    item: getData(state, [PROGRAM_HIGHLIGHTS, ownProps.id]),
    movies: getData(state, PROGRAM_MOVIES_ITEMS),
    currentCinemaId: getData(state, CLI_CURRENT_CINEMA_ID)
})

const ItemHighlightAccess = ({
    htmlId,
    item,
}) => {
    const { title, text, movieRefID } = item
    const hasTitle = !!title.trim()
    
    return (
        <ItemMovieAccess
            htmlId={htmlId}
            id={movieRefID}
            optionalTitle = {title}
            optionalDescription = {text}
            useMovieTitleAsSubtitle={hasTitle}
            queryStringValues={null}
            filterType={null}
            filterValue={null}
            overviewFilterIgnoreOnPerformances={null}
            dayFilters={null}
        />
    )
}

export default compose(
    connect(mapStateToProps, null),
    toJS()
)(ItemHighlightAccess)